/** Convert "HH:MM" or "HH:MM:SS" to a Date set to that time today. */
export const timeToDate = (inputTime: string) => {
  const [hours, minutes, seconds] = inputTime.split(':').map(Number);
  const newDate = new Date();
  newDate.setHours(hours, minutes, seconds || 0, 0);
  return newDate;
};
